<template>
  <v-container style="max-width:1200px" class="pt-0">
    <ASearchForm
      :modelName="modelName"
      :create="hasEditPermission"
      :dropdownProps="[{type:'text',name: 'Name (contains)', payloadKey: 'name'}]"
      @change="search"
      @create="onCreate"
      ref="ASearchForm"
      class="mb-5"
    ></ASearchForm>
    <ADataTable
      :headers="headers"
      :api="api"
      :sort-by="'listOrder'"
      :sort-desc="false"
      :editAction="hasEditPermission"
      :deleteAction="hasEditPermission"
      :moveActions="hasEditPermission"
      @click:edit="onEdit"
      @click:delete="onDelete"
      @click:move="move"
      :hideTitleBar="true"
      :apiParams="apiParams"
      ref="table"
    ></ADataTable>
    <AFormDialog
      ref="formDialog"
      :fields="formMeta"
      :modelName="modelName"
      :model="model"
      :updateOnlyChanged="false"
      @modified="load"
    ></AFormDialog>
  </v-container>
</template>

<script>
import axios from "../api/axios";
import snackbar from "../mixins/snackbar";
import ConfirmDialogMixin from "../mixins/ConfirmDialogMixin";
import crudFuncsMixin from "../mixins/CRUDFuncs";
import PermissionsHelper from "../mixins/PermissionsHelper";
import ASearchForm from "../components/ASearchForm";
import ADataTable from "../components/ADataTable";
import AFormDialog from "../components/AFormDialog";

export default {
  name: "ModelOneMngmnt",
  mixins: [snackbar, ConfirmDialogMixin, crudFuncsMixin, PermissionsHelper],
  components: {
    ASearchForm,
    ADataTable,
    AFormDialog
  },
  data() {
    return {
      model: "locations",
      modelName: "Location",
      headers: [
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "List Order", value: "listOrder" },
        {
          text: "Require Car #",
          value: "requireCarId",
          format: {
            value: "booleanField1",
            formatter: v => (v ? "Yes" : "No")
          }
        },
        {
          text: "Require Status",
          value: "requireStatus",
          format: {
            value: "booleanField2",
            formatter: v => (v ? "Yes" : "No")
          }
        }
      ],
      apiParams: {},
      formMeta: [
        {
          type: "text",
          label: "Name*",
          queryParam: "name",
          rules: [
            v => (!!v && v.length >= 1) || "Should be atleast 1 characters"
          ],
          value: "",
          updatable: true
        },
        {
          type: "text",
          label: "Description",
          queryParam: "description",
          rules: [],
          value: "",
          updatable: true
        },
        {
          type: "checkbox",
          label: "Require Car # on scan*",
          queryParam: "booleanField1",
          updatable: true,
          supportingField: {
            queryParam: "booleanFiedl1Changed",
            value: true
          }
        },
        {
          type: "checkbox",
          label: "Require Status*",
          queryParam: "booleanField2",
          updatable: true,
          supportingField: {
            queryParam: "booleanFiedl2Changed",
            value: true
          }
        }
      ]
    };
  },
  updated() {
    this.load();
  },
  methods: {
    search(payload) {
      this.apiParams = payload;
    }
  }
};
</script>